import { render, staticRenderFns } from "./sjjd-view.vue?vue&type=template&id=67c40d75&scoped=true&"
import script from "./sjjd-view.vue?vue&type=script&lang=js&"
export * from "./sjjd-view.vue?vue&type=script&lang=js&"
import style0 from "./sjjd-view.vue?vue&type=style&index=0&id=67c40d75&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c40d75",
  null
  
)

export default component.exports